import { useDispatch, useSelector } from "react-redux";
import ColorizeIcon from "@mui/icons-material/Colorize";
import { IDetach } from "../../../models/interactions/Detach";
import Interaction from "../../../models/interactions/Interaction";
import NodeActorDropdown from "../components/NodeActorDropdown";
import NodeAttachPropDropdown from "../components/NodeAttachPropDropdown";
import useUpdateSequenceInteraction from "./UpdateSequenceInteraction.hook";
import {
  openSequencePositionPicker,
  selectSequencePositionPicker,
} from "../../../app/slices/GlobalSlice";
import { applyPickedPropToInteraction } from "./SequencePropPicker.helpers";
import { Prop } from "../../../models/Prop";

export default function DetachNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const detach = props.interaction as IDetach;

  const { updateInteraction } = useUpdateSequenceInteraction();
  const dispatch = useDispatch();
  const sequencePositionPicker = useSelector(selectSequencePositionPicker);

  const isPickerActiveForNode =
    sequencePositionPicker.isOpen &&
    sequencePositionPicker.nodeId === props.nodeId &&
    sequencePositionPicker.positionType === "prop";

  const onChangePropDropdown = (prop: Prop) => {
    updateInteraction(props.nodeId, {
      ...applyPickedPropToInteraction(detach, prop),
    } as IDetach);
  };

  const actorDropdown = (
    <NodeActorDropdown
      label="Actor"
      selectedActorId={detach.playerGuid}
      onClick={(actorId: string) =>
        updateInteraction(props.nodeId, {
          ...detach,
          playerGuid: actorId,
        } as IDetach)
      }
    />
  );

  const propDropdown = (
    <NodeAttachPropDropdown
      selectedPropId={detach.propGuid}
      onChange={onChangePropDropdown}
      accessory={
        <button
          type="button"
          aria-label="Pick on map"
          title="Pick on map"
          data-testid="pick-prop-on-map-button"
          className={
            "group flex h-[32px] w-[32px] items-center justify-center rounded-full border-[2px] transition-all duration-150 " +
            (isPickerActiveForNode
              ? "border-creator-primary bg-creator-primary text-white shadow-[0_0_0_4px_rgba(58,196,255,0.18)]"
              : "border-creator-primary bg-creator-primary-background text-creator-primary hover:bg-creator-primary-washed")
          }
          onClick={() =>
            dispatch(
              openSequencePositionPicker({
                nodeId: props.nodeId,
                positionType: "prop",
                title: "Pick prop",
                presentation: "splitView",
              }),
            )
          }
        >
          <ColorizeIcon fontSize="inherit" className="text-[18px]" />
        </button>
      }
    />
  );

  return (
    <div className="w-full h-full flex flex-col gap-[4px]">
      {propDropdown}
      {actorDropdown}
    </div>
  );
}
